// @see: https://www.gatsbyjs.org/docs/using-fragments/
import { graphql } from "gatsby"
import FragmentProductRelated from '../commerceProductDefault/product-related'

export const query = graphql`
    fragment FragmentProductIndex on commerce_product__default {

        id
        drupal_id
        # drupal_internal__nid
        drupal_internal__product_id
        internal {
            type
        }

        langcode
        title
        path {
            pid
            alias
            langcode
        }
        body {
            summary
        }
        created

        relationships {
            bundle: __typename

            variations {
                ... on commerce_product_variation__default {
                    variationId: drupal_internal__variation_id
                    sku
                    title
                    price {
                        number
                        currencyCode: currency_code
                        formatted
                    }
                    resolvedPrice: resolved_price {
                        number
                        currencyCode: currency_code
                        formatted
                    }
                    calculatedPrice: calculated_price {
                        number
                        currencyCode: currency_code
                        formatted
                    }
                    relationships {
                        bundle: __typename

                        field_images {
                            localFile {
                                childImageSharp {
                                    fluid(maxWidth: 255) {
                                        # ...GatsbyImageSharpFluid
                                        # @see: https://www.gatsbyjs.org/packages/gatsby-image/
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
                }
            }

            # field_menu_item {
            #     title
            # }

            field_category {
                ... on taxonomy_term__kategorie_sklep {
                    name
                }
            }

            # field_related_products {
            #     ... on commerce_product__default {
            #         ...FragmentProductRelated
            #     }
            # }

            # commerce_product_variation__default {
            # 	sku
            #     price {
            #         number
            #         currency_code
            #     }
            #     ... on commerce_product_variation__default {
            #     }
            # }

        }

    }
`